<template>
  <div>
    <title>快递打印记录批次详情</title>
     <section class="orderSect">
      <!--S 检索-->      
      <el-form :inline="true" :model="printFormInline">
        <el-form-item :label="expecttitle">
          <el-date-picker v-model="printFormInline.expectDate" type="daterange" range-separater="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="printFormInline.expectDateOptions"
          :unlink-panels = "true" clearable></el-date-picker>
        </el-form-item>
        <el-form-item label="订单号" class="codeSerIpt">
          <el-input v-model="printFormInline.orderno" placeholder="请输入订单号" clearable></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="printFormInline.phone" placeholder="请输入手机号码" clearable></el-input>
        </el-form-item>
        <el-form-item label="收货人">
          <el-input  v-model="printFormInline.Name" placeholder="请输入收货人" clearable></el-input>
        </el-form-item> 
        <el-form-item>
          <el-button type="primary" @click="getPrintRecordBatchDetails">查询</el-button>
           <el-button type="primary" plain @click="$router.back(-1)">返回</el-button>
        </el-form-item>
      </el-form>
      <!--E 检索-->

      <!--S 快递打印列表-->
      <div class="allOrderTab individualiz">
        <el-form :model="printFormInline" inline size="medium">
          <el-form-item class="borderline">
            <em class="greyColor">发货状态</em>
            <el-checkbox-group v-model="printFormInline.deyStatus" @change="changeStatus">
              <el-checkbox v-for="(item,index) of DeliveryStatusLists" :label="item.value" :key="index">{{item.label}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item class="borderline borderNone">
            <em class="greyColor">打印状态</em>
            <el-checkbox-group v-model="printFormInline.printStatus">
              <el-checkbox v-for="(item,index) of PrintStatusLists" 
                :label="item.value" :key="index"
                v-on:change="sourceChange($event,item)">{{item.label}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>                         
        </el-form>
        <el-table v-loading="loading" :data="printRecordData" ref="expressTable" class="orderTable comTable" border :maxHeight="tableHeight" >     
            <el-table-column type="index" fixed label="序号"></el-table-column>
            <el-table-column label="快递内容" fixed prop="expcontent" sortable width="300">
              <template slot-scope="scope">
                <small>订单号：{{scope.row.orderno}}</small>
                <p class="textFl" :title="scope.row.expcontent">{{scope.row.expcontent}}</p>
                <small>{{expecttitle}}：{{ dateTime(scope.row.recvdate, 2)}}</small>
              </template>
            </el-table-column>
            <el-table-column label="收货信息" prop="fulladdr" sortable width="300" >
              <template slot-scope="scope">
                <div class="shouMsg">
                  <em v-if="scope.row.receivername">{{scope.row.receivername}}</em>
                  <em v-if="scope.row.receivertel">{{scope.row.receivertel}}</em>
                </div>              
                <p v-if="scope.row.fulladdr" class="greyColor textFl" :title="scope.row.fulladdr">{{scope.row.fulladdr}}</p>
              </template>
            </el-table-column>
            <el-table-column label="快递方式" sortable prop="exptype">
              <template slot-scope="scope">{{exptypes[scope.row.exptype]}}</template>
            </el-table-column>
            <el-table-column label="发货状态" prop="deliverstate" sortable>
              <template slot-scope="scope">
                <span :class="[{'blueColor':scope.row.deliverstate==1 || scope.row.deliverstate==3},{'orangeColor':scope.row.deliverstate==0},{'redColor':scope.row.deliverstate==2 || scope.row.deliverstate==6},{'greyColor':scope.row.deliverstate==4},{'greenColor':scope.row.deliverstate==5}]">{{scope.row.deliverstate | deliverStateFilter}}</span>
              </template>
            </el-table-column>
            <el-table-column label="打印状态" prop="bprint" sortable>
              <template slot-scope="scope">
                <span :class="[{'orangeColor':scope.row.bprint==0},{'blueColor':scope.row.bprint==1}]" v-if="scope.row.bprint == 0">待打印</span>
                <span :class="[{'orangeColor':scope.row.bprint==0},{'blueColor':scope.row.bprint==1}]" v-if="scope.row.bprint == 1">已打印</span>
              </template>
            </el-table-column>
            <el-table-column label="筛单状态" prop="screenstate" sortable>
              <template slot-scope="scope">
                <span :class="scope.row.screenstate | screenStateColorFilter">{{scope.row.screenstate | screenStateFilter}}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="100">
              <template slot-scope="scope">
                <span :title="scope.row.bank" class="blueColor" @click="viewDetail(scope.row.expcode)">详情</span>
              </template>
            </el-table-column>
            <template slot="empty">
              <div class="noData"><span>暂无数据</span></div>
            </template>
        </el-table>
      </div>
      <!--S 快递打印列表-->
      <Page :pageTotal="pagebean.totalnum" :currentPage="pagebean.currentpage" @nowPageParam="setPageparam"></Page>
    </section>

    <!--S 快递详情组件-->
    <DeliveryDetail :deliveryDetailBox="expressDetailShow" :expcode="expcode" @closeDDBox="expressDetailShow = false"></DeliveryDetail>
    <!--E 快递详情组件-->
  </div>
</template>
<script>
import { Message, MessageBox } from "element-ui";
import api from '../../apis/api';
import '../../util/stateORtypeFilter.js';
export default {
  name: 'PrintRecordBatchDetail',
  data () {
    return {
      PrintStatusLists: [
        { label: "待打印", value: 0 },
        { label: "已打印", value: 1 }
      ], //打印状态
      DeliveryStatusLists: [ 
        { label: "待发货", value: 0 },
        { label: "已发货", value: 1 },
        { label: "退货", value: 2 },
        { label: "已补发", value: 3 },
        { label: "无效快递", value: 4 },
        { label: "已签收", value: 5 },
        { label: "异常签收", value: 6 },
      ], //发货状态
      printFormInline:{
        orderno: "", //订单号
        expectDate: "", //期望发货日期
        phone:"",//手机号
        Name:"",//收货人
        deyStatus:[],//发货状态
        printStatus:[],//打印状态
        expectDateOptions: {
          shortcuts: [
            {
              text: "今天",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime());
                picker.$emit("pick", [start, end]);
              }
            },{
              text: "最近一周",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit("pick", [start, end]);
              }
            },
            {
              text: "最近一个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit("pick", [start, end]);
              }
            },
            {
              text: "最近三个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit("pick", [start, end]);
              }
            }
          ]
        },
      },
      printRecordData:[],//打印列表数据
      tableHeight: window.innerHeight * 0.8, //表格动态高度
      expressDetailShow:false, //快递详情
      expgenbatchno: '',//打印批次编号
      pagebean: {
        pagesize: 30,
        currentpage: 1
      },//分页
      loading: true,//加载
      expcode: '',//快递编号，用于查看详情
      exptypes: {},//快递方式集合
      expecttitle: '',//期望发货日期标题
    }
  },
  components: {
    Page: resolve => require(["@/components/common/Page.vue"], resolve),
     DeliveryDetail: resolve => require(["@/components/common/DeliveryDetail.vue"], resolve), //快递详情组件
  },
  methods: {
    //动态获取表格高度
    getHeight() {
      let tbHeight = this.$refs.expressTable.$el.offsetTop; //顶部检索条件占据的高度
      this.tableHeight = window.innerHeight - tbHeight - 130;
      //console.log('表格距离顶部高度',tbHeight,'可视区高度',window.innerHeight)
    },

    changeStatus(){
      this.getPrintRecordBatchDetails()
    },

    sourceChange: function(value, target) {
      this.printFormInline.printStatus = value ? [target.value] : []
      this.getPrintRecordBatchDetails()
    },
    
    //设置分页数据
    setPageparam(nowPageSize, nowCurrentPage) {
      if(nowPageSize) {
        this.pagebean.pagesize = nowPageSize
      }
      if(nowCurrentPage) {
        this.pagebean.currentpage = nowCurrentPage
      }
      this.getPrintRecordBatchDetails()
    },

    //获取列表页
    getPrintRecordBatchDetails() {
      this.loading = true
      let params = {
        expgenbatchno: this.expgenbatchno,
        stardate: this.printFormInline.expectDate && this.printFormInline.expectDate[0] ? this.dateTime(this.printFormInline.expectDate[0]) : '',
        enddate: this.printFormInline.expectDate && this.printFormInline.expectDate[1] ? this.dateTime(this.printFormInline.expectDate[1]) : '',
        orderno: this.printFormInline.orderno, //订单号
        name: this.printFormInline.Name,
        mobileNumber: this.printFormInline.phone,
        deliverstate: this.printFormInline.deyStatus,
        bprint: this.printFormInline.printStatus,
        pageparam: this.pagebean
      }
      api.FINDEXPGENBATCHDETAIL(params).then(res => {
        if(res.data.status == '200') {
          this.printRecordData = res.data.data
          this.pagebean = res.data.pagebean
        } else {
          this.printRecordData = []
        }
        this.loading = false
      })
    },

    //查看详情
    viewDetail(expcode) {
      this.expressDetailShow = true
      this.expcode = expcode
    },

    //获取所有的可用快递方式
    getAllExpTypes() {
      if(localStorage.getItem("exptypes")){
        this.exptypes = JSON.parse(localStorage.getItem("exptypes"))
      } else {
        api.GET_ALLEXPMODENAMECACHE({}).then(res => {
          if(res.data.status == '200') {
            console.log(res.data.data)
            this.exptypes = res.data.data.expmodeMap
            localStorage.setItem("exptypes",JSON.stringify(this.exptypes))
          }
        })
      }
    },

  },
  filters:  {
  },
  created() {
    //页面浏览器视窗变化绑定resize事件
    window.addEventListener("resize", this.getHeight);
  },
  mounted() {
    //在dom渲染之后
    setTimeout(() => {
      this.expgenbatchno = this.$route.params ? this.$route.params.expgenbatchno : ''
      this.getHeight();
      this.getPrintRecordBatchDetails()
      this.getAllExpTypes()
      this.expecttitle = localStorage.getItem("pubordprintinfo") ? JSON.parse(localStorage.getItem("pubordprintinfo")).expecttitle : ''
    }, 200);
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight); //销毁监听浏览器视窗变化
  }
}
</script>

<style scoped>
@import "Css/Style.css";
</style>



// WEBPACK FOOTER //
// src/views/DeliveryFolder/PrintRecordBatchDetail.vue